module.exports = __webpack_public_path__ + "img/finance1.054e9db5.png";